export const buildFilterUrl = (parameters, actualUrl, actualChanges, stockFilter) => {
    const builder = [];
    for (let i = 0; i < actualChanges.length; i++) {
        if(actualChanges[i]) {
            if (parameters?.[i] && parameters[i].type !== 'number') {
                builder.push(...actualChanges[i]);
            } else if (parameters?.[i] && 'slider' in parameters[i]) {
                if (actualChanges[i][0] !== parameters[i].slider.min || actualChanges[i][1] !== parameters[i].slider.max) {
                    builder.push(`${parameters[i].slider.url}${Math.floor(actualChanges[i][0])}-${Math.round(actualChanges[i][1])}`);
                }
            }
        }
    }
    if(stockFilter) {
        builder.push(stockFilter);
    }
    actualUrl = [actualUrl, ...builder.sort()].join('/');
    return actualUrl;
}
